export default {
  forRoot() {
    return {
      stepActiveTo: 1
    }
  },
  forStep1() {
    return {
      isValidated: false,
      formDatas: null
    }
  },
  forStep2() {
    return {
      isValidated: false,
      formDatas: null
    }
  },
  forStep3() {
    return {
      isValidated: false,
      formDatas: null
    }
  },
  forStep4() {
    return {
      isValidated: false,
      formDatas: null
    }
  }
}
